var React = require('react');

function DividerPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"common-divider","fill":"none","stroke":"rgb(250,250,240)","strokeWidth":"2","d":"M1440.21,30.81c-22,1-540.85-136.81-908.55,171.73C311,387.66,133.71,402.47.34,353.6"}));
}

DividerPath.defaultProps = {"viewBox":"0 0 1440.25 378.52"};

module.exports = DividerPath;

DividerPath.default = DividerPath;
